export const createPhoneApi = (fetchApi) => {
  function sendSMSQR(phoneNumber) {
    return fetchApi(`/PhoneNumberQr?phoneNumber=${phoneNumber}&content=true`, "POST");
  }

  return {
    sendSMSQR,
  };
};
